import { render, staticRenderFns } from "./LocationsTable.vue?vue&type=template&id=3e787495&scoped=true"
import script from "./LocationsTable.vue?vue&type=script&lang=js"
export * from "./LocationsTable.vue?vue&type=script&lang=js"
import style0 from "./LocationsTable.vue?vue&type=style&index=0&id=3e787495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e787495",
  null
  
)

export default component.exports